export default "__VITE_ASSET__f33fadab__"